'use strict';

var DataExtractScheduledController = function DataExtractScheduledController($scope) {
  $scope.$on('grid:beforeUpdateBoundData', function (event, data) {
    $scope.numberOfRows = data && data.length || 0;
  });
};
DataExtractScheduledController.$inject = ['$scope'];
module.exports = DataExtractScheduledController;